import { render, staticRenderFns } from "./SupplierGroupImportModal.vue?vue&type=template&id=306b8ab6&scoped=true"
import script from "./SupplierGroupImportModal.vue?vue&type=script&lang=js"
export * from "./SupplierGroupImportModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierGroupImportModal.vue?vue&type=style&index=0&id=306b8ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306b8ab6",
  null
  
)

export default component.exports